import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../../styles/variables';

export const TrimLineFilterFrame = styled.div`
  padding: 24px;
`;

export const TrimLineListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: Audi Type;
`;

export const OptionWrapper = styled.div`
  font-family: Audi Type;
`;
